import appNavItemTypeCheckers from '../../types/appNavItemTypeCheckers';

const getBoardIdsInApp = ({ app }: { app: V3.App }) => {
  try {
    return app.navigationSettings.sections.reduce((acc, section) => {
      const sectionIds = section.items.reduce((itemAcc, item) => {
        if (appNavItemTypeCheckers.isBoard(item)) {
          return [...itemAcc, item.boardId];
        }
        if (appNavItemTypeCheckers.isSignOffBoard(item)) {
          return [...itemAcc, ...item.boardId];
        }
        if (appNavItemTypeCheckers.isAllAssets(item)) {
          return [...itemAcc, ...(item.boards || []).map((b) => b.id)];
        }
        return itemAcc;
      }, [] as string[]);

      return [...acc, ...sectionIds];
    }, [] as string[]);
  } catch (e) {
    return [];
  }
};

export default getBoardIdsInApp;
